<template>
  <el-dialog
    title="选择银行"
    :visible.sync="dialogVisible"
    width="800px"
    height="500px">
    <div>
      <!-- 操作指引 -->
      <div class="guide-tip">
        <span class="guide-label">操作指引：</span>
        <span class="guide-content">当银行无法选择匹配的支行时，可选择该支行所在城市的支行或分行，如：供应商提供的【中国农业银行顺德锦园支行】，系统无法匹配该支行时，可选择【中国农业银行顺德支行】；若无支行时，可选择【中国农业银行顺德分行】</span>
        <span class="guide-content">只能显示20条数据，请输入支行名称进行搜索</span>
      </div>

      <div style="margin-bottom: 20px;">
        <el-row :gutter="12">
          <el-col :span="6">
            <el-select v-model="where.bank_type" size="mini" placeholder="请选择银行类型" clearable @change="handleBankTypeChange" filterable>
              <el-option v-for="item in bank_list" :key="item.label" :label="item.label" :value="item.label"></el-option>
            </el-select>
          </el-col>
          <!-- <el-col :span="6">
            <el-input v-model="where.city" size="mini" placeholder="请输入所在城市" ></el-input>
          </el-col> -->
          <el-col :span="6">
            <el-input v-model="where.branch_name" size="mini" placeholder="请输入支行名称"></el-input>
          </el-col>
          <el-col :span="6">
            <el-button size="mini" type="primary" @click="searchs">搜索</el-button>
            <el-button size="mini" @click="resetSearch">重置</el-button>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-table
          :data="branch_list"
          :default-sort = "{}"
          border
          @selection-change="handleSelectionChange"
          style="width: 100%">
          <el-table-column prop="label" label="支行名称"></el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="selectFun(scope.row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
      </div> -->
    </div>
    <div class="personnel-footer">
      <el-button size="mini" type="info" @click="closeFun">取 消</el-button>
    </div>
  </el-dialog>

</template>

<script>
import Http from "../common/Http";
export default {
  name: "SelectBank",
  data(){
    return {
      dialogVisible:false,
      loading:false,
      where:{
        bank_type:"",
        city:"",
        branch_name:""
      },
      pageData:{
        list:[],
        page:1,
        total:0,
        pageSize:20
      },
      bank_list:[],
      branch_all_list:[],
      selectData:[],
      branch_list:[],
      callback_fun:undefined,
    }
  },
  mounted() {
    //this.getList();
  },
  methods:{
    initConfig(){
      this.where = {
        bank_type:"",
        city:"",
        branch_name:""
      }
      this.pageData = {
        list:[],
        page:1,
        total:0,
        pageSize:20
      };
      this.bank_list = [];
      this.branch_list = [];
      this.callback_fun=undefined;
      this.selectData = [];
    },
    show({},callback_fun){
      const that = this;
      that.initConfig();
      that.getList();
      that.dialogVisible=true;
      if(typeof callback_fun === "function"){
        that.callback_fun = callback_fun;
      }
    },
    selectFun(row){
      if(typeof this.callback_fun === "function"){
        this.callback_fun(row);
        this.callback_fun = undefined;
      }
      this.dialogVisible=false;
    },
    confirmFun(){
      if(typeof this.callback_fun === "function"){
        this.callback_fun(this.selectData);
        this.callback_fun = undefined;
      }
      this.dialogVisible=false;
    },
    closeFun(){
      if(typeof this.callback_fun ==="function"){
        this.callback_fun=undefined;
      }
      this.dialogVisible=false;
    },
    getList() {
      const that = this;
      that.loading=true;
      that.branch_list = [];
      that.selectData = [];
      that.bank_list = [];
      // 先获取银行类型列表
      Http.get("https://devshare.gdzawy.com:8091/api/payment-center/payment/cbs/list/revBankType",{},res=>{
        if(res.code) {
          // 过滤相同label的数值
          const uniqueLabels = new Set();
          this.bank_list = (res.data || []).filter(item => {
            if (uniqueLabels.has(item.label)) {
              return false;
            }
            uniqueLabels.add(item.label);
            return true;
          });
          this.branch_all_list = this.bank_list;
        }
      })
    },
    searchs() {
      let city = this.where.city || "";
      let branch_name = this.where.branch_name || "";

      // 保存原始数据备份，避免多次过滤导致数据丢失
      if (!this.originalBranchList) {
        this.originalBranchList = [...this.branch_all_list];
      }

      // 从原始数据开始过滤
      let filteredList = [...this.originalBranchList];
      filteredList.sort((a, b) => a.label.localeCompare(b.label));
      if(city) {
        filteredList = filteredList.filter(item =>
          item.label.indexOf(city) !== -1 ||
          (item.city && item.city.indexOf(city) !== -1)
        );
      }
      if(branch_name) {
        filteredList = filteredList.filter(item =>
          item.label.indexOf(branch_name) !== -1
        );
      }
      console.log(this.originalBranchList);
      this.branch_list = filteredList.slice(0, 20) || [];

      console.info(this.branch_list);
    },
    resetSearch() {
      this.where = {
        bank_type:"",
        city:"",
        branch_name:""
      }
      this.originalBranchList = null;
      this.pageData.page = 1
      this.getList()
    },
    pageChange(i) {
      this.pageData.page = i;
      this.getList();
    },
    handleBankTypeChange(value) {
      const that = this;
      that.loading=true;
      this.branch_list = [];
      // 先获取银行类型列表
      Http.get("https://devshare.gdzawy.com:8091/api/payment-center/payment/cbs/list/cnapsCode  ",{bank_type:value},res=>{
        if(res.code) {
          let data = res.data || [];
          data.sort((a, b) => a.label.localeCompare(b.label));
          this.branch_all_list = data;
          this.branch_list = data.slice(0, 20);
          this.originalBranchList = data;
        }
      })
      that.loading=false;
    },
    handleSelectionChange(val) {
      this.selectData = val
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../common";
.guide-tip {
  margin-bottom: 15px;
  padding: 10px 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
  font-size: 13px;
  line-height: 1.6;
}
.guide-label {
  color: #409EFF;
  font-weight: bold;
}
.guide-content {
  color: #606266;
}
.personnel-footer{
  margin-top: 10px;
  width: 100%;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/components/SelectBank.vue